/**
 * Материал Developer Pack (ТЗ §6, режим 11).
 *
 * Набор перечислен, а не выведен из данных, — и это осознанно: пакет задан
 * самим требованием как список символов и операторов, а не как то, что чаще
 * встречается в языке. Вывести его из раскладки нельзя: там нет разницы между
 * `=` и `==`, а именно она здесь и тренируется.
 *
 * Группы идут в порядке, в котором одно опирается на другое: сначала парные
 * скобки, затем слеши и кавычки, и только потом операторы — `<=` показывать
 * раньше, чем `<` и `=`, значит показывать сочетание из незнакомых половин.
 *
 * Фрагменты — собственный материал проекта: короткие выражения из букв, цифр
 * и токенов пакета. Чужой код в упражнение не берётся: у него есть автор и
 * лицензия (ТЗ §8.4).
 */

/** Группы токенов в порядке открытия. */
export const DEVELOPER_GROUPS: readonly (readonly string[])[] = [
  ['(', ')'],
  ['[', ']'],
  ['{', '}'],
  ['<', '>'],
  ['/', '\\'],
  ['"', "'", '`'],
  ['=', '=='],
  ['!=', '<=', '>='],
  ['+', '-', '*', '%'],
  ['&&', '||'],
];

/**
 * Фрагменты кода, внутри которых тренируются токены.
 *
 * Поле `tokens` не перечисляется вручную: оно вычисляется по самому тексту
 * (см. `fragments.ts`), иначе список и фрагмент разошлись бы при первой же
 * правке.
 */
export const DEVELOPER_TEXTS: readonly string[] = [
  'run(x)',
  'next(i)',
  'sort(items)',
  'list[0]',
  'items[i]',
  'data[key]',
  '{name}',
  '{total}',
  '{count}',
  '<div>',
  '<span>',
  '<body>',
  'src/app',
  'docs/api',
  'dir\\file',
  'tmp\\logs',
  '"text"',
  "'text'",
  '`text`',
  '"ok"',
  'x = 1',
  'n = 0',
  'a == b',
  'x == y',
  'a != b',
  'i <= n',
  'n >= 0',
  'i + 1',
  'n - 1',
  'x * 2',
  'n % 2',
  'a && b',
  'x || y',
  'if (i < n)',
  'if (a != b)',
  'sum(a + b)',
  'list[i] = 0',
  'x = (a + b) * 2',
  'a == b && x != y',
  // Материал, добавленный ради разнообразия (этап ABM). На первой группе
  // посильных фрагментов было три при десяти элементах в занятии: одно и то
  // же по кругу. Ранние группы пополнены заметнее поздних — там это и болело.
  'get(x)',
  'set(y)',
  'log(msg)',
  'find(key)',
  'load(path)',
  'save(file)',
  'open(name)',
  'close(id)',
  'push(item)',
  'call(fn)',
  'add(ab)',
  'sum(list)',
  'max(ab)',
  'min(xy)',
  'row[0]',
  'row[1]',
  'name[i]',
  'line[n]',
  'args[0]',
  'cell[j]',
  'path[end]',
  'text[start]',
  '{id}',
  '{key}',
  '{value}',
  '{size}',
  '{first}',
  '{last}',
  '{page}',
  '{limit}',
  '<p>',
  '<ul>',
  '<li>',
  '<head>',
  '<main>',
  '<label>',
  '<footer>',
  '<section>',
  'src/main',
  'src/utils',
  'app/core',
  'lib/parse',
  'docs/guide',
  'data/raw',
  'home\\user',
  'logs\\old',
  'temp\\build',
  'files\\new',
  '"name"',
  '"value"',
  '"path"',
  '"error"',
  "'name'",
  "'value'",
  "'small'",
  '`line`',
  '`code`',
  '`total`',
  'y = 2',
  'i = 0',
  'size = 10',
  'count = 1',
  'total = 0',
  'flag = 1',
  'x == 0',
  'i == n',
  'key == id',
  'size == 8',
  'a != 0',
  'x != y',
  'name != last',
  'i <= 9',
  'x <= max',
  'n >= 1',
  'size >= 4',
  'a + b',
  'x + 2',
  'total + 1',
  'i - 1',
  'n - 2',
  'size - 4',
  'a * b',
  'x * 3',
  'total * 2',
  'i % 3',
  'x % 10',
  'a && x',
  'b && y',
  'x || 0',
  'a || b',
  'if (x > 0)',
  'if (i == n)',
  'if (a && b)',
  'if (x <= max)',
  'while (i < n)',
  'for (i = 0)',
  'max(ab) + 1',
  'sum(list) / 2',
  'row[i] = x',
  'data[key] = 0',
  'name = "text"',
  'path = "src/app"',
  'flag = a != b',
  'x = (a - b) % 2',
  'if (a == b || x != y)',
  'log(name) && save(file)',
];
